import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, PanelGroup, Panel, ButtonToolbar, Button} from 'react-bootstrap'
import {connectForm} from '../../core/redux/form'
import extract from '../../core/extract'
import Chart, {totalAngle} from '../../core/components/Chart'
import TypeaheadBar, {matcher} from '../../core/components/TypeaheadBar'
import ButtonToggle from '../../core/components/ButtonToggle'
import {TodoCriteria} from '../models'
import {TODO_CRITERIA_UPDATED} from '../actions'
import i18n from '../i18n'
import style from './TodoSearch.less'

function expectedDateStatusStyle(status) {
    switch(status.value) {
        case 'Todo': return 'success'
        case 'TodoWithin12Hours': return 'warning'
        case 'Timeout': return 'danger'
    }
}

function expectedDateStatusReducer(result, status) {
    if (result.length == 0) {
        result = [
            {value: 'Todo', count: 0},
            {value: 'TodoWithin12Hours', count: 0},
            {value: 'Timeout', count: 0}
        ]
    }

    const resultStatus = result.find((s) => s.value == status.value)

    if (resultStatus) {
        resultStatus.count = status.count
    }
    return result
}

class TodoSearch extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            expectedDateStatus: []
        }
    }

    componentWillMount() {
        const {aggregations} = this.props
        
        const expectedDateStatus = aggregations.expectedDateStatus.reduce(expectedDateStatusReducer, [])
        this.setState({expectedDateStatus})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.aggregations != this.props.aggregations) {
            const {aggregations} = nextProps

            const expectedDateStatus = aggregations.expectedDateStatus.reduce(expectedDateStatusReducer, [])
            this.setState({expectedDateStatus})
        }
    }

    render() {
        const {dispatch, form, criteria, range, aggregations, ...others} = this.props
        const {expectedDateStatus} = this.state

        const agencySource = matcher({
            source: aggregations.agencies,
            identify: (a) => a.label
        })

        const clientCompanySource = matcher({
            source: aggregations.clientCompanies,
            identify: (c) => c.label
        })

        const expectedCommandSource = matcher({
            source: aggregations.expectedCommands,
            identify: (c) => extract(i18n.expectedCommandEnum, c.value)
        })

        const actorSource = matcher({
            source: aggregations.actors,
            identify: (c) => extract(i18n.actorEnum, c.value)
        })

        const operatorSource = matcher({
            source: aggregations.operators,
            identify: (c) => c.label
        })

        const panelHeader = (text) => (
            <h5>{text}</h5>
        )

        const expectedDateField = (field) => {
            var value

            if (field.value && field.value.expectedDateStart && field.value.expectedDateEnd) {
                value = 'TodoWithin12Hours'
            } else if (field.value && field.value.expectedDateStart) {
                value = 'Todo'
            } else if (field.value && field.value.expectedDateEnd) {
                value = 'Timeout'
            } else {
                value = null
            }

            function onChange(value) {
                var start
                var end

                switch(value) {
                    case 'TodoWithin12Hours':
                        start = new Date()
                        end = new Date(start.getTime())
                        end.setHours(end.getHours() + 12)

                        field.onChange({expectedDateStart: start.toISOString(), expectedDateEnd: end.toISOString()})
                        break
                    case 'Todo':
                        start = new Date()
                        start.setHours(start.getHours() + 12)

                        field.onChange({expectedDateStart: start.toISOString(), expectedDateEnd: null})
                        break
                    case 'Timeout':
                        end = new Date()

                        field.onChange({expectedDateStart: null, expectedDateEnd: end.toISOString()})
                        break
                    default:
                        field.onChange({expectedDateStart: null, expectedDateEnd: null})
                        break
                }
            }

            return {...field, value, onChange}
        }

        const expectedDateStatusChartTotal = totalAngle({
            source: expectedDateStatus,
            angle: 220,
            identify: (s) => s.count
        })

        return (
            <div className={style.default}>
                <div className={style.expectedDateStatus}>
                    <h4>{i18n.expectedDateStatus}</h4>
                    <Row>
                        <Col sm={6}>
                            <Chart donut brand
                                kind='Pie'
                                ratio='square'
                                donutWidth={60}
                                startAngle={250}
                                total={expectedDateStatusChartTotal}
                                display={(m) => m.count}
                                identify={(m) => m.count}
                                value={expectedDateStatus} />
                            <small>{range.count} {i18n.todos}</small>
                        </Col>
                        <Col sm={6}>
                            <ButtonToggle
                                {...expectedDateField(form(['expectedDateStart', 'expectedDateEnd']))}>
                                {expectedDateStatus.map((status, index) => status.count > 0 && (
                                    <Button block
                                        key={index}
                                        bsStyle={expectedDateStatusStyle(status)}
                                        value={status.value}>
                                        {extract(i18n.expectedDateStatusEnum, status.value)}
                                    </Button>
                                ))}
                            </ButtonToggle>
                        </Col>
                    </Row>
                </div>
                <PanelGroup>
                    <Panel collapsible
                        eventKey={1}
                        header={panelHeader(i18n.searchCompany)}>
                        <TypeaheadBar
                            size='small'
                            source={clientCompanySource}
                            identify={(c) => c.value}
                            display={(c) => c.label + ' (' + c.count + ')'}
                            placeholder={i18n.search}
                            {...form.clientCompany()} />
                    </Panel>
                    <Panel collapsible
                        eventKey={2}
                        header={panelHeader(i18n.searchAgency)}>
                        <TypeaheadBar
                            size='small'
                            source={agencySource}
                            identify={(a) => a.value}
                            display={(a) => a.label + ' (' + a.count + ')'}
                            placeholder={i18n.search}
                            {...form.agency()} />                    
                    </Panel>
                    <Panel collapsible defaultExpanded
                        eventKey={3}
                        header={panelHeader(i18n.searchActor)}>
                        <TypeaheadBar
                            size='small'
                            source={actorSource}
                            identify={(c) => c.value}
                            display={(c) => extract(i18n.actorEnum, c.value) + ' (' + c.count + ')'}
                            placeholder={i18n.search}
                            {...form.actor()} />
                    </Panel>
                    <Panel collapsible
                        eventKey={4}
                        header={panelHeader(i18n.searchOperator)}>
                        <TypeaheadBar
                            size='small'
                            source={operatorSource}
                            identify={(c) => c.value}
                            display={(c) => c.label + ' (' + c.count + ')'}
                            placeholder={i18n.search}
                            {...form.operator()} />
                    </Panel>
                    <Panel collapsible
                        eventKey={5}
                        header={panelHeader(i18n.searchExpectedCommand)}>
                        <TypeaheadBar
                            size='small'
                            source={expectedCommandSource}
                            identify={(c) => c.value}
                            display={(c) => extract(i18n.expectedCommandEnum, c.value) + ' (' + c.count + ')'}
                            placeholder={i18n.search}
                            {...form.expectedCommand()} />
                    </Panel>
                </PanelGroup>
            </div>
        )
    }
}

TodoSearch = connectForm({
    target: 'criteria',
    schema: TodoCriteria.schema,
    action: TODO_CRITERIA_UPDATED
})(TodoSearch)

TodoSearch = connect((state) => ({
    criteria: state.workflow.todo.criteria,
    range: state.workflow.todo.range,
    aggregations: state.workflow.todo.aggregations
}))(TodoSearch)

export default TodoSearch


// WEBPACK FOOTER //
// ./lib/workflow/components/TodoSearch.js